import { useNavigate } from 'react-router';
import { getLogoutUrl } from '../../../utils/auth';
import WindowWrapper from '../../../utils/windowWrapper';

const loginPageUrl = '/login';

export const useClientSessionOmitter = () => {
  const navigate = useNavigate();

  const clearSession = () => {
    localStorage.clear();
  };

  const endMashboardSession = () => {
    clearSession();
    navigate(loginPageUrl, { replace: true });
  };

  const endCMMISession = () => {
    const logoutUrl = getLogoutUrl();

    if (!logoutUrl) {
      endMashboardSession();
      return;
    }

    clearSession();
    WindowWrapper.setLocation(logoutUrl);
  };

  return {
    endCMMISession,
    endMashboardSession
  };
};
